/**
 * @typedef {Object} AddUserRequest
 * @property {string} firstName - User's first name
 * @property {string} lastName - User's last name
 * @property {string} email - User's email address
 * @property {string} mobileNumber - User's mobile number
 * @property {string} idType - Type of ID (Iqama or National ID)
 * @property {string} idNumber - ID number
 * @property {string[]} roles - Array of role IDs assigned to the user
 * @property {string} userName - User Name
 */

/**
 * Creates an AddUserRequest object from form data
 * @param {Object} formData - The form data from state
 * @param {string} formData.firstName - User's first name
 * @param {string} formData.lastName - User's last name
 * @param {string} formData.email - User's email
 * @param {string} formData.mobileNumber - User's mobile number
 * @param {string} formData.IdType - Type of ID
 * @param {string} formData.idNumber - ID number
 * @param {string[]} formData.Roles - Array of role IDs
 * @returns {AddUserRequest} The formatted request object ready for API call
 */
export const createAddUserRequest = (formData) => ({
    firstName: formData.firstName || '',
    lastName: formData.lastName || '',
    email: formData.email || '',
    mobileNumber: formData.mobileNumber || '',
    idType: formData.IdType || '',
    idNumber: formData.idNumber || '',
    roles: formData.Roles || [],
    userName: formData.idNumber || '',
});



/**
 * @typedef {Object} EditUserRequest
 * @property {string} firstName - User's first name
 * @property {string} lastName - User's last name
 * @property {string} email - User's email address
 * @property {string} mobileNumber - User's mobile number
 */

/**
 * Creates an EditUserRequest object from form data
 * @param {Object} formData - The form data from state
 * @param {string} formData.firstName - User's first name
 * @param {string} formData.lastName - User's last name
 * @param {string} formData.email - User's email
 * @param {string} formData.mobileNumber - User's mobile number
 * @returns {EditUserRequest} The formatted request object ready for API call
 */
export const createEditUserRequest = (formData) => ({
    firstName: formData.firstName || '',
    lastName: formData.lastName || '',
    email: formData.email || '',
    mobileNumber: formData.mobileNumber || '',
});
